import {
  fetchAutocompleteSuggestions,
  fetchCurrentLocation,
} from '@/features/shop/services/GeoLocation/fetchers'
import { type GeoCoordinates } from '@/features/shop/services/GeoLocation/types'
import { queryOptions, useQuery } from '@tanstack/react-query'

const ReverseGeocodeQuery = 'Reverse geocode'
export type ReverseGeocodeQueryKey = [typeof ReverseGeocodeQuery, GeoCoordinates]
export const reverseGeocodeQueryOptions = (coordinates: GeoCoordinates) =>
  queryOptions({
    queryKey: [ReverseGeocodeQuery, coordinates],
    queryFn: fetchCurrentLocation,
  })

export type AutocompleteSuggestionsQueryKey = readonly [
  'Autocomplete suggestions',
  { query: string },
]
const autocompleteSuggestionsQueryOptions = (query: string, sessionToken: string) =>
  // sessionToken is excluded from the query key since the result should not be cached
  // based on the session token as it is just an optimization for the API request
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: ['Autocomplete suggestions', { query }] as const,
    queryFn: (context) => fetchAutocompleteSuggestions(context, sessionToken),
  })

export const useQueryAutocompleteSuggestions = (query: string, sessionToken: string) => {
  return useQuery({
    ...autocompleteSuggestionsQueryOptions(query, sessionToken),
    enabled: Boolean(query),
    staleTime: Infinity,
    placeholderData: (previousData) => previousData,
  })
}
